export default __webpack_public_path__ + "static/10_30-e85a35d042df2733619674135f9be8fb.png";